import type { LeaderboardRecord } from "@memorang/types";

type Response = {
	leaderboardUserRecord: LeaderboardRecord;
};

const fetchUserLeaderboard = async (
	_tenantId: string,
	_scope: string,
): Promise<Response> => {
	return {
		leaderboardUserRecord: {
			xp: 0,
			rank: 0,
			username: "",
			avatar: "",
			level: 0,
		},
	};
};

export default fetchUserLeaderboard;
